import React from 'react';
import _ from 'lodash';

import Dropzone from 'components/Dropzone';
import DocumentWithFilename from 'components/DocumentWithFilename';
import ImageWithFilename from 'components/ImageWithFilename';

import wrongFormatImage from 'assets/icons/reject.svg';

import './styles.css';

interface SingleFileUploadProps {
  file: any;
  onFileDrop: (files) => void;
  onFileRemove: () => void;
  wrongFormat?: boolean;
  acceptedFileTypes: string;
  placeholderIcon: any;
  placeholderText: string;
  fileLabel?: string;
}

export const WrongFormat = () => (
  <div className="WrongFormat colab-centered">
    <img src={wrongFormatImage} alt="Wrong Format" />
    <div className="colab-bold colab-sidepadding-1">Unsupported file type</div>
  </div>
);

export const UploadFilePlaceholder = ({placeholderIcon, placeholderText}) => (
  <div className="UploadFilePlaceholder colab-centered">
    <div className="colab-sidepadding-1">
      <img src={placeholderIcon} />
    </div>
    <div className="UploadFilePlaceholder__text colab-bold colab-centered">
      {placeholderText}
    </div>
  </div>
);

export const UploadedFileOption = ({
  file,
  filePreview,
  fileName,
  onFileRemove
}) => {
  const isDocument = !_.includes(file.type, 'image/');

  return (
    <div className="UploadedFileOption colab-centered-v">
      {isDocument && <DocumentWithFilename filename={fileName} />}
      {!isDocument && (
        <ImageWithFilename imageUrl={filePreview} filename={fileName} />
      )}

      {onFileRemove && (
        <div
          className="UploadedFileOption__options--remove colab-bold colab-clickable colab-sidepadding-1"
          onClick={() => onFileRemove(file)}>
          Remove
        </div>
      )}
    </div>
  );
};

const SingleFileUpload = ({
  file,
  onFileDrop,
  wrongFormat,
  onFileRemove,
  acceptedFileTypes,
  placeholderIcon,
  placeholderText,
  fileLabel
}: SingleFileUploadProps) => (
  <div className="SingleFileUpload FileUpload">
    {_.isNil(file) && (
      <Dropzone
        onDrop={onFileDrop}
        multiple={false}
        acceptedFileTypes={acceptedFileTypes}
        defaultComponent={
          <React.Fragment>
            {wrongFormat && <WrongFormat />}
            {!wrongFormat && (
              <UploadFilePlaceholder
                placeholderIcon={placeholderIcon}
                placeholderText={placeholderText}
              />
            )}
          </React.Fragment>
        }
      />
    )}
    {!_.isNil(file) && (
      <div className="FileUpload__container">
        <div className="FileUpload__container__header colab-bold">
          {fileLabel}
        </div>
        <UploadedFileOption
          key={file.name}
          onFileRemove={onFileRemove}
          file={file}
          fileName={file.name}
          filePreview={file.preview}
        />
      </div>
    )}
  </div>
);

export default SingleFileUpload;
